import type { SVGProps } from 'react'

import { Wrapper } from './Wrapper'

export const IconHeaderCoin = (props: SVGProps<SVGSVGElement>) => (
	<Wrapper>
		<svg width='100' height='100' viewBox='0 0 100 100' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
			<path
				d='M62.2247 83.589C74.9649 77.4712 78.0486 57.4254 69.1122 38.8154C60.1758 20.2054 42.6034 10.0785 29.8632 16.1962C17.1229 22.314 14.0393 42.3598 22.9757 60.9698C31.9121 79.5798 49.4845 89.7068 62.2247 83.589Z'
				fill='#99CCFF'
			/>
			<path
				d='M68.9937 79.7399L67.4209 80.4993C70.8736 77.1 73.3113 72.1709 74.2751 65.977L74.2752 65.9765C75.6436 57.1176 73.7338 47.3081 69.5657 38.6103C65.3977 29.9126 58.9503 22.2822 51.1909 17.807L51.1895 17.8062C45.7099 14.6699 40.2933 13.5199 35.4391 14.1212L37.1475 13.3009L37.1475 13.3009L37.151 13.2992C42.8677 10.499 50.1893 10.9256 57.7511 15.2832C65.2972 19.6482 71.6196 27.1006 75.7139 35.6498C79.8082 44.1992 81.6534 53.8018 80.2971 62.4426L80.297 62.4437C78.9652 71.0557 74.8104 77.0544 69.0015 79.7362L69.0015 79.7361L68.9937 79.7399Z'
				fill='#0000FF'
				stroke='#0000FF'
			/>
			<path
				opacity='0.3'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M63.6014 31.1301L20.6914 55.9101C21.3898 57.8513 22.1909 59.754 23.0914 61.6101L66.9114 36.3101C65.9131 34.5185 64.8078 32.7887 63.6014 31.1301Z'
				fill='white'
			/>
			<path
				opacity='0.3'
				fillRule='evenodd'
				clipRule='evenodd'
				d='M50.5401 19.0001C49.9701 18.6801 49.4401 18.3701 48.8301 18.1001L18.1001 35.8601C17.5997 40.6627 17.9209 45.5154 19.0501 50.2101L59.9201 26.6401C57.1909 23.641 54.0294 21.066 50.5401 19.0001Z'
				fill='white'
			/>
			<path
				fillRule='evenodd'
				clipRule='evenodd'
				d='M37.4671 58.3305L37.4559 58.337L40.8416 64.2011L65.0007 50.2529L61.615 44.3887L42.4857 55.433L37.2061 46.2884L32.1875 49.1859L37.4671 58.3305Z'
				fill='#0000FF'
				fillOpacity='0.2'
			/>
			<path
				d='M35.7285 57.4734L56.3652 43.5251H59.8876L63.2733 49.3893L39.1142 63.3376L35.7285 57.4734Z'
				fill='#E4A28D'
			/>
			<path d='M35.6415 63.3857L32.1875 45.4248H35.4791L44.1402 60.4262L39.0956 63.3857H35.6415Z' fill='#E4A28D' />
			<path d='M56.4345 43.5254L32.2754 57.4736L35.6611 63.3378L59.8202 49.3896L56.4345 43.5254Z' fill='#FFEBE3' />
			<path d='M27.0069 48.3224L35.668 63.3237L40.6866 60.4262L32.0256 45.4248L27.0069 48.3224Z' fill='#FFEBE3' />
		</svg>
	</Wrapper>
)
